@if (label) {
	<label class="top">{{ label }}</label>
}

@if (departmentOptions()) {
	<form [formGroup]="form">
		<fieldset>
			<ic-single-select-field
				dataTest="department-select"
				formControlName="departmentId"
				[label]="'medication.found_medication_incidents.steps.date_location.department' | translate"
				[options]="departmentOptions()"
			/>

			@if (form.get("roomId") && roomOptions()) {
				<ic-single-select-field
					dataTest="room-select"
					formControlName="roomId"
					[label]="'medication.found_medication_incidents.steps.date_location.room' | translate"
					[options]="roomOptions()"
				/>
			}

			@if (form.get("description"); as control) {
				<div class="input-group" [class.error]="control.touched && control.errors">
					<input
						data-test="description-input"
						formControlName="description"
						id="description"
						placeholder="{{
							'medication.found_medication_incidents.steps.date_location.placeholder.other' | translate
						}}"
						type="text"
					/>
					<medication-input-error [errors]="control.errors" [touched]="control.touched" />
				</div>
			}
		</fieldset>
	</form>
}
